export const MEDIA_VIEWER_KINDS = {
  IMAGE: "image",
  VIDEO: "video",
} as const;

export type MediaViewerKind = (typeof MEDIA_VIEWER_KINDS)[keyof typeof MEDIA_VIEWER_KINDS];

export type MediaViewerState = {
  open: boolean;
  src: string;
  title: string;
  kind: MediaViewerKind;
};

export type OpenMediaViewerOptions = {
  src: string;
  title?: string;
  kind?: MediaViewerKind;
};

export const createMediaViewerState = (): MediaViewerState => ({
  open: false,
  src: "",
  title: "",
  kind: MEDIA_VIEWER_KINDS.IMAGE,
});

export const openMediaViewer = (state: MediaViewerState, { src, title = "", kind = MEDIA_VIEWER_KINDS.IMAGE }: OpenMediaViewerOptions): void => {
  if (!src) return;
  state.src = src;
  state.title = title;
  state.kind = kind;
  state.open = true;
};

export const closeMediaViewer = (state: MediaViewerState): void => {
  state.open = false;
};

export const resetMediaViewer = (state: MediaViewerState): void => {
  state.open = false;
  state.src = "";
  state.title = "";
  state.kind = MEDIA_VIEWER_KINDS.IMAGE;
};

export const handleMediaViewerError = (state: MediaViewerState): void => {
  // 読み込み失敗時にクラッシュさせない
  resetMediaViewer(state);
};
